/* eslint-disable array-callback-return */
import React from "react";
import { useState, useEffect, useRef } from "react";
import { Row } from "reactstrap";
import {
  assessmentFlow,AccountType
} from "../../components/constants/constants";
import { find, size } from "lodash";
import { B2CAssessmentHeader } from "./B2C_AssessmentHeader";
import { B2CQuizBody } from "./B2C_QuizBody";
import { B2CPagination } from "./B2C_Pagination";
import { B2CAssessmentButtons } from "./B2C_AssessmentButtons";
import WarningAIGradingModel from "../../components/modals/WarningAIGradingModel";
import { useMobileView } from "../../speech_pages/components/MobileViewContext";
let visited_pages = [];
let pagination_color_decision = [];
export const B2CAssessmentRunner = ({
  assessmentStarted,
  isReview,
  data,
  isStopTimer,
  setIsStopTimer,
  IsonRecorder,
  setIsonRecorder,
  timer,
  isOpenAdditionalResourceModal,
  setOpenAdditionalResourceModal,
  additionalResourceToggle,
  setSpeakingUrl,
  currentPage,
  onblur,
  answers,
  resetAudio,
  setresetAudio,
  setCurrentPage,
  creatQuizDataAndSubmit,
  isSubmitting,
  setShowTimeWarning,
  visualizerToggle,
  setessayWordsCount,
  FormSubmit,
}) => {
  let { isMobileView, observedDiv } = useMobileView();
  const [assessmentData, setAssessmentData] = useState(data);
  const [AisubmissionCounter, setAisubmissionCounter] = useState(data?.remaining_credits);
  const [sectionCounter, setsectionCounter] = useState({});
  const [GWarningModal, setGWarningModal] = useState(false);
  const lastexerciseId = useRef(null);
  const GWarningToggle = () => setGWarningModal(!GWarningModal);
  useEffect(() => {
    setAssessmentData(data);
    setAisubmissionCounter(data?.remaining_credits);
  }, [data]);
  const [CurrentSection, setCurrentSection] = useState(1);
  const [currentPageOfSection, setCurrentPageOfSection] =
    useState(CurrentSection);

  const [currentSectionPage, setcurrentSectionPage] = useState(11);
  const [currentSectionPageOnSection, setcurrentSectionPageOnSection] =
    useState(currentSectionPage);

  useEffect(() => {
    setcurrentSectionPageOnSection(currentSectionPage);
  }, [currentSectionPage]);

  useEffect(() => {
    setCurrentPageOfSection(CurrentSection);
  }, [CurrentSection]);

  useEffect(() => {
    if (
      data.completed_at &&
      data.completed_at !== null && data.sections
    ) {
        setCurrentSection(data.sections[0].section_number);
        setcurrentSectionPage((`${data.sections[0].section_number}1`));
      }
  }, [data]);

  if (
    data.completed_at &&
    data.completed_at !== null
  ) {
      isReview = true;
      setIsStopTimer(true);
  }
  let bottomPanelSection;
  let bottomPanelPage;
  let pagesOfCurrentSection;
  let isAiGradingexercise;
  let isWritingexercise;
  return (
    <div ref={observedDiv} data-tc="assessment-start-page">
      {assessmentData && assessmentData.sections && (
      <div className="b2c-smpe-5 Quizbody">
        {assessmentData.sections.map((section, id) => {
            // lastSectionNumber = section.section_number;
            if (
              parseInt(currentPageOfSection) ===
              parseInt(section.section_number) || (assessmentData.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && data.user_type === AccountType.STUDENT && !isReview)
            ) {
              return (
                section &&
                section.pages.map((page, id) => {

                    if (
                      parseInt(currentSectionPageOnSection) ===
                      parseInt(`${section.section_number}${page.page_number}`) || (assessmentData.assessment_flow === assessmentFlow.SEQUENTIAL_EARLY_STOP && data.user_type === AccountType.STUDENT && !isReview)
                    ) 
                    {
                      pagesOfCurrentSection = section.total_pages;
                      bottomPanelSection = section.section_number;
                      bottomPanelPage = page.page_number;
                      const subBodyclass = isMobileView? "" : "quizsub_body";
                      if (page.writing_exercises.length === 0) {
                        return (
                          page &&
                          page.exercises.map((exercise, exercise_id) => {
                            isAiGradingexercise = exercise.ai_grading_task;
                            let found_selected_answer = find(visited_pages, [
                              "section_number",
                              section.section_number,
                            ]);
                            if (found_selected_answer) {
                              let found_exercise = find(
                                found_selected_answer.pages,
                                ["exercise_id", exercise.id]
                              );
                              if (!found_exercise) {
                                found_selected_answer.pages.push({
                                  exercise_total_questions: size(
                                    exercise.questions
                                  ),
                                  page_number: page.page_number,
                                  exercise_questions: exercise.questions,
                                  page_id: page.id,
                                  exercise_id: exercise.id,
                                  pagination_number: currentSectionPage,
                                });
                              }
                            } else {
                              visited_pages.push({
                                section_number: section.section_number,
                                pages: [
                                  {
                                    exercise_total_questions: size(
                                      exercise.questions
                                    ),
                                    page_number: page.page_number,
                                    exercise_questions: exercise.questions,
                                    page_id: page.id,
                                    exercise_id: exercise.id,
                                    pagination_number: currentSectionPage,
                                  },
                                ],
                              });
                            }
  
                            return (
                            <>
                                <div className="Header b2c-smps-5">
                                    <B2CAssessmentHeader
                                    assessmentStarted={assessmentStarted}
                                    creatQuizDataAndSubmit={creatQuizDataAndSubmit}
                                    isReview={isReview}
                                    data={assessmentData}
                                    isStopTimer={isStopTimer}
                                    setIsStopTimer={setIsStopTimer}
                                    timer={timer}
                                    setShowTimeWarning={setShowTimeWarning}
                                    exercise={exercise}
                                    />
                                </div>
                                <div className={`Question__description quizmain ${subBodyclass} b2c-smps-5 custom_scroll`}>
                                    <B2CQuizBody
                                        section_id={section.id}
                                        page_id={page.id}
                                        exercise={exercise}
                                        setIsonRecorder= {setIsonRecorder}
                                        isReview={isReview}
                                        setOpenAdditionalResourceModal={
                                        setOpenAdditionalResourceModal
                                        }
                                        isOpenAdditionalResourceModal={
                                        isOpenAdditionalResourceModal
                                        }
                                        additionalResourceToggle={
                                        additionalResourceToggle
                                        }
                                        resetAudio={resetAudio}
                                        setresetAudio={setresetAudio}
                                        setSpeakingUrl={setSpeakingUrl}
                                        currentPage={currentPage}
                                        onblur={onblur}
                                        answers={answers}
                                        data={assessmentData}
                                        visualizerToggle={visualizerToggle}
                                        setessayWordsCount={setessayWordsCount}
                                        isAiGradingexercise={isAiGradingexercise}
                                        GWarningToggle={GWarningToggle}
                                        AisubmissionCounter={AisubmissionCounter}
                                        lastexerciseId={lastexerciseId}
                                    />
                                </div>
                            </>
                            );
                          })
                        );
                      } else {
                        return (
                          page &&
                          page.writing_exercises.map((exercise, exercise_id) => {
                            isAiGradingexercise = true;
                            isWritingexercise = true;
                            let found_selected_answer = find(visited_pages, [
                              "section_number",
                              section.section_number,
                            ]);
                            if (found_selected_answer) {
                              let found_exercise = find(
                                found_selected_answer.pages,
                                ["exercise_id", exercise.id]
                              );
                              if (!found_exercise) {
                                found_selected_answer.pages.push({
                                  exercise_total_questions: size(
                                    exercise.questions
                                  ),
                                  page_number: page.page_number,
                                  exercise_questions: exercise.questions,
                                  page_id: page.id,
                                  exercise_id: exercise.id,
                                  pagination_number: currentSectionPage,
                                });
                              }
                            } else {
                              visited_pages.push({
                                section_number: section.section_number,
                                pages: [
                                  {
                                    exercise_total_questions: size(
                                      exercise.questions
                                    ),
                                    page_number: page.page_number,
                                    exercise_questions: exercise.questions,
                                    page_id: page.id,
                                    exercise_id: exercise.id,
                                    pagination_number: currentSectionPage,
                                  },
                                ],
                              });
                            }
  
                            return (
                                <>
                                {!isReview && (
                                <div className="Header b2c-smps-5">
                                    <B2CAssessmentHeader
                                    assessmentStarted={assessmentStarted}
                                    creatQuizDataAndSubmit={creatQuizDataAndSubmit}
                                    isReview={isReview}
                                    data={assessmentData}
                                    isStopTimer={isStopTimer}
                                    setIsStopTimer={setIsStopTimer}
                                    timer={timer}
                                    setShowTimeWarning={setShowTimeWarning}
                                    exercise={exercise}
                                    />
                                </div>
                                )}
                                <div className={`Question__description quizmain ${subBodyclass} b2c-smps-5 custom_scroll`}>
                                    <B2CQuizBody
                                        section_id={section.id}
                                        page_id={page.id}
                                        setIsonRecorder= {setIsonRecorder}
                                        exercise={exercise}
                                        isReview={isReview}
                                        setOpenAdditionalResourceModal={
                                        setOpenAdditionalResourceModal
                                        }
                                        isOpenAdditionalResourceModal={
                                        isOpenAdditionalResourceModal
                                        }
                                        additionalResourceToggle={
                                        additionalResourceToggle
                                        }
                                        setSpeakingUrl={setSpeakingUrl}
                                        currentPage={currentPage}
                                        resetAudio={resetAudio}
                                        setresetAudio={setresetAudio}
                                        onblur={onblur}
                                        answers={answers}
                                        data={assessmentData}
                                        setessayWordsCount={setessayWordsCount}
                                        isAiGradingexercise={isAiGradingexercise}
                                        GWarningToggle={GWarningToggle}
                                        AisubmissionCounter={AisubmissionCounter}
                                        lastexerciseId={lastexerciseId}
                                    />
                                </div>
                                </>
                            );
                          })
                        );
                      }
                    }
                  
                })
              );
            }
        })}
        <Row className="col-12 g-0">
          <div className="col-12 d-flex">
          {isReview ||
              assessmentData.assessment_flow ===
              assessmentFlow.SEQUENTIAL_EARLY_STOP ? null : (
              <div className="col-6 px-0 d-flex align-items-end b2c-footer">
                  <B2CPagination
                  data={assessmentData}
                  answers={answers}
                  visited_pages={visited_pages}
                  currentPage={CurrentSection}
                  setCurrentPage={setCurrentSection}
                  currentSectionPage={currentSectionPage}
                  setCurrentSectionPage={setcurrentSectionPage}
                  pagination_color_decision={pagination_color_decision}
                  isAiGradingexercise={isAiGradingexercise}
                  AisubmissionCounter={AisubmissionCounter}
                  setAisubmissionCounter={setAisubmissionCounter}
                  />
              </div>
          )}
          <div className={isReview ||
              assessmentData.assessment_flow ===
              assessmentFlow.SEQUENTIAL_EARLY_STOP ? "col-12 ps-0 d-flex justify-content-end" : isMobileView ? "col-6" : "col-12 d-flex justify-content-end"}>
              <B2CAssessmentButtons
              data={assessmentData}
              IsonRecorder={IsonRecorder}
              pagesOfCurrentSection={pagesOfCurrentSection}
              currentSection={bottomPanelSection}
              setCurrentSection={setCurrentSection}
              currentSectionPage={bottomPanelPage}
              setCurrentSectionPage={setcurrentSectionPage}
              total_sections={assessmentData && assessmentData.sections && assessmentData.sections.length}
              isSubmitting={isSubmitting}
              isReview={isReview}
              isAiGradingexercise={isAiGradingexercise}
              GWarningToggle={GWarningToggle}
              AisubmissionCounter={AisubmissionCounter}
              setAisubmissionCounter={setAisubmissionCounter}
              sectionCounter={sectionCounter}
              setsectionCounter={setsectionCounter}
              />
          </div>
          </div>
        </Row>
        <WarningAIGradingModel
          isOpen={GWarningModal}
          toggle={GWarningToggle}
          data={assessmentData}
          isWritingexercise={isWritingexercise}
          pagesOfCurrentSection={pagesOfCurrentSection}
          currentSection={bottomPanelSection}
          setCurrentSection={setCurrentSection}
          currentSectionPage={bottomPanelPage}
          setCurrentSectionPage={setcurrentSectionPage}
          total_sections={assessmentData && assessmentData.sections && assessmentData.sections.length}
          FormSubmit={FormSubmit}
        />
      </div>
      )}
    </div>
  );
};
